import { Injectable } from '@angular/core';

import { BeehiveApiService, castDataToEntity } from '../beehive-api.service.js';
import { Discount } from './discount.model.js';
import { map, Observable, of } from 'rxjs';
import { DiscountSubscriptionCheck } from './lib/discount.interfaces.js';
import { Course } from '../course/course.model.js';
import { ShoppingCartRegistration } from '../../frontend/shopping-cart/shopping-cart.interfaces';
import { Workshop } from '../workshop/workshop.model';
import { ApiResponse } from '../api.interfaces';
import { objectFilter, objectMap } from '../../util/object';
import { Customer } from '../customer/customer.model';
import { Registration } from '../registration/registration.model';
import { Payment } from '../payment/payment.model';

@Injectable({ providedIn: 'root' })
export class DiscountService extends BeehiveApiService<Discount> {
  protected entityType = Discount;
  protected endpoint = 'discounts';

  retrieveCode(
    code: string,
    constraints: {
      customer?: Customer | null;
      course?: Course | null;
      workshop?: Workshop | null;
    },
  ): Observable<Discount | null> {
    return this.http
      .get<ApiResponse<Discount>>(this.getUrl('code', code), {
        params: objectMap(
          objectFilter(constraints, (k, v) => !!v),
          (k, v) => [k, v!.id],
        ),
      })
      .pipe(map((response) => castDataToEntity(Discount, response.data)));
  }

  checkSubscriptions(
    registration: ShoppingCartRegistration,
  ): Observable<DiscountSubscriptionCheck[]> {
    // todo: subscriptions not implemented yet, always return empty list.
    return of([]);
    // return of([
    //   {
    //     type: DiscountSubscriptionType.UitPas,
    //     applicable: true,
    //     effectAmount: 20,
    //     effectType: DiscountEffectType.Flat,
    //   },
    // ]);
  }

  apply(discount: Discount, registration: Registration) {
    return this.post<any, Payment | null>([discount.id, 'apply'], {
      registration: { id: registration.id },
    });
  }
}
